import { render } from "./TaxCasePage.vue?vue&type=template&id=4a86207e"
import script from "./TaxCasePage.vue?vue&type=script&lang=js"
export * from "./TaxCasePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__